import apiClient from "./apiClient";

/**
 * Reminders and the time zone they keep to (UX_CONCEPT.md §6.2–6.3).
 */

export type ReminderKind = "emergency" | "bp" | "trip" | "plan";

/** Schedules a reminder for 20:00 the traveller's time; returns when. */
export async function remindTonight(
  kind: ReminderKind,
  tripId?: string,
): Promise<Date> {
  const response = await apiClient.post("/notifications/reminders", {
    kind,
    tripId,
  });
  return new Date(response.data.data.dueAt);
}

const SENT_KEY = "healthpass.timezoneSent";

/**
 * Tells the server this browser's time zone, once per session, so reminders
 * arrive in the traveller's daytime. Silent on failure: a reminder at the
 * wrong hour is better than an error about it.
 */
export async function syncTimeZone(): Promise<void> {
  let timeZone: string;
  try {
    timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
    if (!timeZone || sessionStorage.getItem(SENT_KEY) === timeZone) return;
  } catch {
    return;
  }
  try {
    await apiClient.put("/notifications/timezone", { timeZone });
    try {
      sessionStorage.setItem(SENT_KEY, timeZone);
    } catch {
      // Sent again next time; harmless.
    }
  } catch {
    // Retried on the next page load.
  }
}
